import { useParams } from 'react-router'

import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { useFetchInvoice } from '@features/invoices/hooks/useFetchInvoice'
import { isDepositInvoice } from '@features/invoices/utils/depositInvoices/isDepositInvoice'
import { isFinalInvoice } from '@features/invoices/utils/depositInvoices/isFinalInvoice'

import { InvoiceEditorUrlParams } from '../../../types/invoiceEditorUrlParams'
import { useInvoiceEditorDocumentType } from './useInvoiceEditorDocumentType'

export const useIsCreditNoteFromDepositOrFinalInvoice = () => {
  const { documentId } = useParams<InvoiceEditorUrlParams>()
  const { isCreditNote } = useInvoiceEditorDocumentType()

  const shouldFetch = isCreditNote && !!documentId

  const { invoice: sourceInvoice } = useFetchInvoice(InvoiceDocumentType.Invoice, shouldFetch ? documentId : undefined)

  return shouldFetch && (isDepositInvoice(sourceInvoice?.billingStage) || isFinalInvoice(sourceInvoice?.billingStage))
}
